(function () {
	const initQuizContent = () => {
        var answers = [];
		$('.quiz-answer').click(function(){
          const next = $(this).closest('div.current').next().is('.quiz-step');
          answers.push($(this).attr('data-answerIndex'));
          if (next) {
            $(this).closest('div.current').removeClass('current').next().addClass('current');
            return;
          } else {
            $(this).closest('div.current').removeClass('current');
            Result(answers);
          }
        
        });
	};
    const Result = (answers) => {
      let m = {};
      let maxCount = 0;
      let res = null;
  
      for (let x of answers) {
          m[x] = (m[x] || 0) + 1;
          if (m[x] > maxCount) {
              maxCount = m[x];
              res = x;
          }
      }
      console.log(res);
      switch(res) {
        case "a":
          $('#result .title').html("General Wellness Support");
          jQuery.getJSON('/products/black-seed-oil-120-capsules-chronic-pain.js', function(product) {
            $('#result .seggested-product').html('<a href="'+ product.url +'">Try Holistq Black Seed Oil Capsules for overall health, vitality, and daily nourishment.</a>');
          } );
          break;
        case "b":
          $('#result .title').html("Joint Health & Mobility");
          jQuery.getJSON('/products/black-seed-oil-120-capsules-chronic-pain.js', function(product) {
            $('#result .seggested-product').html('<a href="'+ product.url +'">Consider Holistq Black Seed Oil 5% TQ for inflammation support and movement ease.</a>');
          } );
          break;
        case "c":
          $('#result .title').html("Immune Boosting");
          jQuery.getJSON('/products/immuno-boost.js', function(product) {
            $('#result .seggested-product').html('<a href="'+ product.url +'">Opt for Holistq Immuno Boost for enhanced immune defense and resilience.</a>');
          } );
          break;
        case "d":
          $('#result .title').html("Energy & Recovery");
          jQuery.getJSON('/products/3-tq-black-seed-oil-100ml-with-dropper.js', function(product) {
            $('#result .seggested-product').html('<a href="'+ product.url +'">Try Holistq Black Seed Oil 3% TQ for a daily energy boost and recovery support.</a>');
          } );
          break;
        default:
          $('#result .title').html("General Wellness Support");
          jQuery.getJSON('/products/black-seed-oil-120-capsules-chronic-pain.js', function(product) {
            $('#result .seggested-product').html('<a href="'+ product.url +'">Try Holistq Black Seed Oil Capsules for overall health, vitality, and daily nourishment.</a>');
          } );
      }
      $('.result-wrapper').addClass('current');
    };
	document.addEventListener("shopify:section:load", function () {
		initQuizContent();
	});

	initQuizContent();
})();
